import { getActiveSchool } from './activeSchool';

/** JWT-роль аккаунта (Coach / Owner / Member / Admin) — не меняется при переключении школы. */
export function getAccountRole() {
    return localStorage.getItem('accountRole') || localStorage.getItem('role') || '';
}

export function isPlatformAdmin() {
    if (getAccountRole() === 'Admin') return true;
    if (localStorage.getItem('profileType') === 'Admin') return true;
    return false;
}

/** Роль для меню после переключения школы (может быть Owner в личной микро-школе). */
export function getNavRole() {
    return localStorage.getItem('role') || '';
}

export function setAccountRole(role) {
    if (role) localStorage.setItem('accountRole', role);
}

export function isFreelanceCoach() {
    if (localStorage.getItem('isFreelance') === 'true') return true;
    if (getActiveSchool()?.isFreelanceSchool) return true;
    return false;
}

export function markFreelanceCoach() {
    localStorage.setItem('isFreelance', 'true');
}

/** Роль в текущей выбранной школе (owner / coach / member / …). */
export function getSchoolAccessRole() {
    return getActiveSchool()?.accessRole || '';
}

/** Роль для меню и роутов: владелец микро-школы видит меню Owner в своём кабинете. */
export function getEffectiveNavRole() {
    if (isPlatformAdmin()) return 'Admin';
    const accessRole = getSchoolAccessRole();
    if (accessRole === 'owner' || accessRole === 'demo') return 'Owner';
    const account = getAccountRole();
    if (account === 'Admin') return 'Admin';
    if (accessRole === 'coach') return 'Coach';
    if (accessRole === 'member') return 'Member';
    if (accessRole === 'staff') return 'Staff';
    return getNavRole() || account || 'Member';
}

export function isCoachAccount() {
    return getAccountRole() === 'Coach' && getSchoolAccessRole() !== 'owner';
}

export function canManageSchoolFinances() {
    return getEffectiveNavRole() === 'Owner' || getEffectiveNavRole() === 'Admin';
}

export function canManageStaff() {
    return canManageSchoolFinances();
}

/** Может искать школы и подавать заявку как тренер. */
export function canFindSchoolAsCoach() {
    if (isFreelanceCoach()) return true;
    if (getAccountRole() === 'Coach') return true;
    if (getSchoolAccessRole() === 'coach') return true;
    return false;
}
